import { c as _c } from "react/compiler-runtime";
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import type { IBreadcrumbItem } from '@/components/Molecules/Breadcrumb/Breadcrumb';
import { ResultList } from '@/components/Molecules/ResultList/ResultList';
import { Stack } from '@/components/Molecules/Stack/Stack';
import { SubscribeButton } from '@/components/Molecules/SubscribeButton/SubscribeButton';
import { PageHeader } from '@/components/Organisms/PageHeader/PageHeader';
import useTranslation from '@/hooks/useTranslation';
import type { IContentItem, IPagination, ISeriesItem } from '@/interfaces';
import type { Translate } from 'next-translate';
import type { FC } from 'react';
import styled from 'styled-components';
import { SeriesViewHeaderSection } from './SeriesViewHeaderSection';
export interface ISeriesItemProps {
  pagination: IPagination;
  series: ISeriesItem;
  insights: IContentItem[];
}
export const seriesBreadcrumbs = (t: Translate): IBreadcrumbItem[] => [{
  label: t('common:SiteSection.insights'),
  url: '/insights'
}, {
  label: t('common:SiteSection.series'),
  url: '/series'
}];
export const SeriesViewPage: FC<ISeriesItemProps> = t0 => {
  const $ = _c(20);
  const {
    series,
    insights,
    pagination
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = seriesBreadcrumbs(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== series) {
    t2 = !series.isArchived && <SubscribeButton series={series} initialSubscriptionState={series.isSubscribed} />;
    $[2] = series;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== series.title || $[5] !== t1 || $[6] !== t2) {
    t3 = <PageHeader sticky={true} breadCrumbs={t1} title={series.title} callToAction={t2} />;
    $[4] = series.title;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = insights.length > 0 ? insights[0].url : null;
  let t5;
  if ($[8] !== series || $[9] !== t4) {
    t5 = <Section><SeriesViewHeaderSection series={series} firstInsightUrl={t4} /></Section>;
    $[8] = series;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== insights || $[12] !== pagination || $[13] !== series.id || $[14] !== t) {
    t6 = insights.length > 0 && <CenteredPageContent featured={true}><Stack><h2 className="cds-t-h2">{t("Sections.latest_insights")}</h2><ResultList items={insights} pagination={pagination} urlTemplate={`/series/${series.id}/insights?page={page}`} cardProps={{
          withSeries: false
        }} /></Stack></CenteredPageContent>;
    $[11] = insights;
    $[12] = pagination;
    $[13] = series.id;
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t5 || $[18] !== t6) {
    t7 = <>{t3}{t5}{t6}</>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
const Section = styled.div`
    margin-bottom: var(--size-grid-double);
`;